import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/close.svg';
const _withScopeId = n => (_pushScopeId("data-v-d0cae3ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-page"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
import GetForm from './horForm';
import PutForm from '@/view/putin/part/form';
import EPutForm from '@/view/eputin/part/form';
import leafForm from './leafForm';
import SliderBar from './sliderbar';
import SliderBarMobile from './sliderbar/mobile.vue';
import ShortSlider from './shortSlider';
import NavHeader from './nav';
import PutInNav from './nav/putin.vue';
import BottomFooter from './footer';
import { ref, watch, computed, provide } from 'vue';
import { isMobile } from '@/utils';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'layout',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const isPartner = ref(route.query.back !== undefined);
    const notUrl = ref('');
    const name = ref('');
    const formDesc = ref(`<div style="font-weight: 500;">认证后免费获得<span style="color: #FF7D00; font-size: 14px; line-height:20px; font-weight: 500;">50</span>份电子合同</div>`);
    watch(() => router.currentRoute.value.path, toPath => {
      notUrl.value = route.meta.notUrl;
      name.value = route.meta.name;
    }, {
      immediate: true,
      deep: true
    });
    const showForm = ref(false);
    const showFormModal = () => {
      showForm.value = true;
    };
    const putVisible = ref(false);
    const showPutinVisible = val => {
      if (val) {
        sessionStorage.setItem('source', val);
      }
      putVisible.value = true;
    };
    const formTxt = computed(() => {
      return {
        note: {
          // 笔迹登陆
          submitSource: 6,
          title: '立即体验 笔迹登录',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        },
        signIn: {
          // 签字上墙
          submitSource: 7,
          title: '联系您的专属客服',
          desc: '<span style="font-size: 14px">请完善以下信息，我们会尽快与您取得联系</span>',
          buttonText: '提交申请'
        },
        education: {
          // 教育行业
          submitSource: 8,
          title: '立即体验电子签约全流程',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        },
        finance: {
          // 金融行业
          submitSource: 9,
          title: '立即体验电子签约全流程',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        },
        security: {
          // 担保行业
          submitSource: 10,
          title: '立即体验电子签约全流程',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        },
        hr: {
          // 人力行业
          submitSource: 11,
          title: '立即体验电子签约全流程',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        },
        property: {
          // 地产行业
          submitSource: 12,
          title: '立即体验电子签约全流程',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        },
        eSign: {
          // 电子签名
          submitSource: 13,
          title: '立即体验电子签约全流程',
          desc: '为你的团队量身定制，多场景&多行业的解决方案'
        }
      }[name.value] || {
        submitSource: 1,
        title: '立即体验电子签约全流程',
        desc: '为你的团队量身定制，多场景&多行业的解决方案'
      };
    });
    const closeFormModal = () => {
      showForm.value = false;
    };
    provide('showFormModal', showFormModal);
    provide('showPutinVisible', showPutinVisible);
    provide('closeFormModal', closeFormModal);
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [!notUrl.value ? (_openBlock(), _createBlock(_unref(NavHeader), {
        key: 0
      })) : (_openBlock(), _createBlock(PutInNav, {
        key: 1,
        name: name.value
      }, null, 8, ["name"])), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")]), !notUrl.value ? _withDirectives((_openBlock(), _createBlock(_unref(BottomFooter), {
        key: 2
      }, null, 512)), [[_vShow, !isPartner.value]]) : _createCommentVNode("", true)]), _createVNode(_component_a_modal, {
        visible: showForm.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => showForm.value = $event),
        footer: null,
        width: "460px",
        destroyOnClose: true,
        centered: ""
      }, {
        closeIcon: _withCtx(() => [_hoisted_3]),
        default: _withCtx(() => [name.value === 'leaflet' ? (_openBlock(), _createBlock(_unref(leafForm), {
          key: 0,
          "main-title": "免费试用",
          desc: "认证后免费获得<span style='color: #1664FF'>100</span>份电子合同"
        })) : (_openBlock(), _createBlock(_unref(GetForm), {
          key: 1,
          class: "d-forms",
          layout: "horizontal",
          "submit-source": _unref(formTxt).submitSource,
          "main-title": _unref(formTxt).title,
          desc: _unref(formTxt).desc,
          "button-text": _unref(formTxt).buttonText
        }, null, 8, ["submit-source", "main-title", "desc", "button-text"]))]),
        _: 1
      }, 8, ["visible"]), !notUrl.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!_unref(isMobile)() ? _withDirectives((_openBlock(), _createBlock(_unref(SliderBar), {
        key: 0
      }, null, 512)), [[_vShow, !isPartner.value]]) : _withDirectives((_openBlock(), _createBlock(SliderBarMobile, {
        key: 1
      }, null, 512)), [[_vShow, !isPartner.value]])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [!_unref(isMobile)() ? (_openBlock(), _createBlock(_unref(ShortSlider), {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_component_a_modal, {
        visible: putVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => putVisible.value = $event),
        footer: null,
        width: "460px",
        destroyOnClose: true,
        centered: ""
      }, {
        closeIcon: _withCtx(() => [_hoisted_4]),
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tralForm))), name.value ? (_openBlock(), _createBlock(_unref(EPutForm), {
          key: 0,
          class: "d-forms",
          layout: "horizontal",
          mainTitle: "免费试用",
          desc: "专业一对一服务，提供最合适你的产品",
          method: "顶部导航栏"
        })) : (_openBlock(), _createBlock(_unref(PutForm), {
          key: 1,
          class: "d-forms",
          layout: "horizontal",
          mainTitle: "免费试用",
          desc: formDesc.value,
          method: "顶部导航栏"
        }, null, 8, ["desc"]))]),
        _: 1
      }, 8, ["visible"])], 64))], 64);
    };
  }
};